import axios from 'axios';

export const API_BASE_URL =
  import.meta.env.MODE === 'development'
    ? 'http://localhost:3001'
    : 'https://api.us.catalyzed.ai';

export const apiClient = axios.create({
  ...axios.defaults,
  baseURL: API_BASE_URL,
  timeout: 10_000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => {
    // Convert arrays to comma-separated strings
    return Object.entries(params)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          const filteredValues = value
            .filter((v) => v !== undefined)
            .map(encodeURIComponent);
          return `${key}=${filteredValues.join(',')}`;
        } else if (value instanceof Date) {
          return `${key}=${value.toISOString()}`;
        } else if (value === undefined) {
          return '';
        }
        return `${key}=${value}`;
      })
      .join('&');
  },
});

apiClient.interceptors.request.use(
  function (config) {
    // Ensure credentials are always included
    config.withCredentials = true;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

export type QueryOptions = {
  enabled?: boolean;
  retry?: boolean;
  keepPreviousData?: boolean;
};
